// there are 3 other files in this project named "shipment-type.ts"
// 2 of them are different types than this one(pickup vs delivery)
// todo:  resolve these types into a more coherent paradigm

export enum ShipmentType {
    Truck = 0,
    Container = 1
}

export const ShipmentTypeMetadata = {
    '0': {
        display: 'Truck',
        class: 'truck',
        value: 0
    },
    '1': {
        display: 'Container',
        class: 'container',
        value: 2
    }
};
